export default {
  title: {
    en: 'All done!',
  },
  text: {
    en: 'Your subscription plan has been successfully updated.',
  },
  buttonTitle: {
    en: 'Got it',
  },
}
